import { render, staticRenderFns } from "./sign-file.vue?vue&type=template&id=03c0523c&scoped=true&"
import script from "./sign-file.vue?vue&type=script&lang=js&"
export * from "./sign-file.vue?vue&type=script&lang=js&"
import style0 from "./sign-file.vue?vue&type=style&index=0&id=03c0523c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c0523c",
  null
  
)

export default component.exports